import { render, staticRenderFns } from "./SurveyPaperDetailEdit.vue?vue&type=template&id=4d60f6e7&scoped=true"
import script from "./SurveyPaperDetailEdit.vue?vue&type=script&lang=js"
export * from "./SurveyPaperDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60f6e7",
  null
  
)

export default component.exports